const helpMenuSensorsAndConnectors = `
    <p>All the things you place a sensor on will show up in this list.</p>
    <p>
        Scroll through to view the status of individual sensors. Click on a sensor to bring up details. Search
        for a specific sensor or groups of sensors, and save your search results for quick recollection.
    </p>
`;

const helpMenuFoldersAndLabelsFolders = `
    <p>Use folders to organize your sensors</p>
    <p>
        Make folders for floors and rooms, or use them to group sensors by importance. Folders are hierarchical,
        which means a sensor can only belong to one folder at a time.
    </p>
    <p>
        You can apply rules to folders, which makes it easy to manage many sensors at once. In addition, any rule
        or access setting applied to a folder automatically applies to all folders within that folder and below.
    </p>
`;

const helpMenuFoldersAndLabelsLabels = `
    <p>Tag sensors with labels for more control</p>
    <p>
        Labels give you an extra level of organization. If you have sensors across many folders that all require
        the same rule, using labels will save you time: apply a label to all the sensors,
        and apply the rule to the label.
    </p>
`;

export default {
    sensor_list_wasnt_loaded: 'There was an error while loading the list',
    sensor_list_network_offline: 'You are offline. Some functionality may be unavailable.',
    sensor_list_network_online: 'You are online again. Updating...',

    star_was_added: 'Thing is now starred',
    star_wasnt_added: 'Thing could not be starred. <br>Please refresh the page and try again.',
    star_was_removed: 'Thing is no longer starred',
    star_wasnt_removed: 'Could not make thing unstarred. <br>Please refresh the page and try again.',

    comment_was_created: 'Comment successfully created',
    comment_was_updated: 'Comment successfully updated',
    comment_was_removed: 'Comment successfully removed',

    navbar_category_was_created: 'Category successfully created',
    navbar_category_wasnt_created: 'The category could not be created. <br>Please refresh the page and try again.',
    navbar_category_was_updated: 'Category successfully updated',
    navbar_category_wasnt_updated: 'The category could not be updated. <br>Please refresh the page and try again.',
    navbar_category_was_moved: 'Category successfully moved',
    navbar_category_wasnt_moved: 'The category could not be moved. <br>Please refresh the page and try again.',
    navbar_category_was_removed: 'Category successfully removed',
    navbar_category_wasnt_removed: 'The category could not be removed. <br>Please refresh the page and try again.',

    navbar_view_was_created: 'View successfully created',
    navbar_view_wasnt_created: 'The view could not be created. <br>Please refresh the page and try again.',
    navbar_view_was_updated: 'View successfully updated',
    navbar_view_wasnt_updated: 'The view could not be updated. <br>Please refresh the page and try again.',
    navbar_view_was_moved: 'View successfully moved',
    navbar_view_wasnt_moved: 'The view could not be moved. <br>Please refresh the page and try again.',
    navbar_view_was_removed: 'View successfully removed',
    navbar_view_wasnt_removed: 'The view could not be removed. <br>Please refresh the page and try again.',

    label_was_created: 'Label successfully created',
    label_wasnt_created: 'The label could not be created. <br>Please refresh the page and try again.',
    label_was_updated: 'Label successfully updated',
    label_wasnt_updated: 'The label could not be updated <br>Please refresh the page and try again.',
    label_was_removed: 'Label successfully removed.',
    label_wasnt_removed: 'The label could not be removed. <br>Please refresh the page and try again.',

    folder_was_created: 'Folder successfully created',
    folder_wasnt_created: 'The folder could not be created. <br>Please refresh the page and try again.',
    folder_was_updated: 'Folder successfully updated',
    folder_wasnt_updated: 'The folder could not be updated. <br>Please refresh the page and try again.',
    folder_was_removed: 'Folder successfully removed',
    folder_wasnt_removed: 'The folder could not be removed. <br>Please refresh the page and try again.',
    folder_was_moved: 'Folder successfully moved',
    folder_wasnt_moved: 'The folder could not be moved. <br>Please refresh the page and try again.',

    ticket_was_submitted: 'The support ticket was submitted, and a receipt will be sent to the email ' +
        'address you entered.',
    ticket_wasnt_submitted: 'The support ticket could not be submitted. Please try again in a few minutes.',

    thing_was_saved: 'Thing successfully saved',
    thing_wasnt_saved: 'The thing could not be saved. <br>Please refresh the page and try again.',


    help_icon_advanced_search_name: 'This is the name of the sensor/thing.',
    help_icon_advanced_search_owner: 'Find sensors associated with a specific user',
    help_icon_advanced_search_status: 'Select one or more of these to only show things with active notifications',
    help_icon_advanced_search_starred: 'Find sensors that are starred',
    help_icon_advanced_search_signal: 'Find things with signal strength within the chosen range.',
    help_icon_advanced_search_location: 'Check this box to find things that are located within the circle in the map ' +
        'below. Move the map around and zoom in or out to change the size of the search area. ' +
        'Note: Things must have a location saved in order to show up in the results.',
    help_icon_advanced_search_labels: 'Find things that have specific labels assigned to them. ' +
        'Enter more than one label to find things with specific label combinations.',
    help_icon_advanced_search_types_and_states: 'Select which thing types to show, then select if they should have a ' +
        'specific current state. ',
    help_icon_advanced_search_battery: 'Fill out one field to find things with a battery level above or below the ' +
        'specified percentage. Fill out both fields to find things with a battery level within that range',
    help_icon_user_settings_roles_assigned: 'These are the roles assigned to user',


    'help_menu_main_alerts-actions': '<p>Rules make sensors even smarter.</p>' +
        '<p>With alerts and actions you can make things automatically ' +
        'happen depending on a sensor’s current status. Create a rule ' +
        'that emails you when someone presses a button, or make one that ' +
        'alerts you when a window is left open.</p><p>Rules can also send ' +
        'the sensor information to another online service, making the possibilities endless.</p>',
    'help_menu_main_dashboard': '<p>Dashboards gives you an at-a-glance visualization of your sensor activity.</p>' +
        '<p>You can create and organize your own dashboards by using the extended search in the "Things" menu and ' +
        'choose "Visualize" and then save it as a dashboard. Dashboards have a default fixed period from today’s ' +
        'date, and you can dynamically adjust the date range.</p>',
    'help_menu_main_sensors_list': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_list_thing': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_list_thing_graph': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_list_search': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_graphs': helpMenuSensorsAndConnectors,
    'help_menu_main_users-and-access_users': '<p>Create and managed users for every person that needs ' +
        'access to DT Studio.</p>' +
        '<p>Each user gets their own notifications, and you' +
        'can define control exactly who can see which sensors.</p>',
    'help_menu_main_users-and-access_roles': '<p>Manage users and access in bulk keep track of access with roles</p>' +
        '<p>To easily manage who has permission to which sensors and features in DT Studio, you can create and ' +
        'assign roles. This also makes notifying several users a simple task: just send the notification to a role, ' +
        'and all the users with that role will get the notification.</p>',
    'help_menu_main_users-and-access_customers': '<p>Customers are like users with an extra layer of privacy.</p>' +
        '<p>If you plan to make apps and sell sensors, we recommend adding users as customers so' +
        'they only have access to their own sensors. It also lets them keep sensors private from all' +
        'other users, including admins, with the option to allow access on a case by case basis.</p>',
    'help_menu_main_folders-and-labels_folders': helpMenuFoldersAndLabelsFolders,
    'help_menu_main_folders-and-labels_folders_folder': helpMenuFoldersAndLabelsFolders,
    'help_menu_main_folders-and-labels_labels': helpMenuFoldersAndLabelsLabels,
    'help_menu_main_folders-and-labels_labels_label': helpMenuFoldersAndLabelsLabels,
    'help_menu_main_developer-settings_api-access': '<p>API access for further development.</p>' +
        '<p>To integrate with our API, the API access must be enabled.' +
        'Enable it under Developer Settings and start creating apps for your sensors. </p>'
};




// WEBPACK FOOTER //
// ./app/services/translation/en.lang.js